import configuration, {
  getEnvironment,
  isProduction,
  isStaging,
} from '@zageno/config';
import { isAuthenticated } from '@zageno/auth';
import { currentUser } from '@zageno/profile';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import isbot from 'isbot';

if (configuration.datadogClientToken && configuration.datadogApplicationId) {
  datadogLogs.init({
    clientToken: configuration.datadogClientToken,
    env: getEnvironment(),
    service: configuration.datadogService,
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    sampleRate: 100,
  });

  if (isbot(navigator.userAgent) === false) {
    datadogRum.init({
      applicationId: configuration.datadogApplicationId,
      clientToken: configuration.datadogClientToken,
      site: 'datadoghq.eu',
      env: getEnvironment(),
      // @todo add configurable project version/deployment id etc.
      //  version: '1.0.0',
      sampleRate: 100,
      sessionReplaySampleRate: 100,
      trackResources: true,
      trackLongTasks: true,
      trackInteractions: true,
      service: configuration.datadogService,
      allowedTracingOrigins: [
        /https:\/\/.*\.zageno\.(com|co\.uk|de)/,
        /https:\/\/zageno\.(com|co\.uk|de)/,
      ],
      defaultPrivacyLevel: 'mask-user-input',
    });
  } else {
    datadogLogs.logger.info('Bot detected, skipping datadogRum.init');
  }
}

(async () => {
  if (await isAuthenticated()) {
    const user = await currentUser();

    datadogRum.setUser({
      id: user.user_id,
      name: user.email,
      email: user.email,
    });

    if (isStaging() || isProduction()) {
      datadogRum.startSessionReplayRecording();
    }
  }
})();

export type Datadog = typeof datadogLogs;

export default datadogLogs;
